<script lang="ts" setup>
import t from "~/utils/translate";
const config = useRuntimeConfig();
</script>

<template>
	<div class="relative h-[350px] md:h-[360px] max-w-[300px] min-w-[290px] m-auto left-0 right-0 bg-cover z-10 mb-20 shadow-lg">
		<div
			class="select-none absolute bg-cover left-0 right-0 h-[330px] md:h-[360px] min-w-[300px] max-w-[320px] m-auto top-6 bg-light-200 dark:bg-dark-700 shadow-xl rounded-2xl dark:shadow-lg dark:shadow-[#00A82645] z-20 mb-20"
			:style="{
				'background-image': `url('${config.public.kenticoDomain}/medialibraries/content.gmgamingsystems.com/Synapse/Misc/swipe-layer.png')`,
			}"
		>
			<div class="object-cover h-[350px] md:h-[360px] grid place-items-center">
				<div>
					<div class="grid place-items-center">
						<UiLoader class="w-14 h-14" />
					</div>

					<div class="mt-4">
						<span class="mt-4 font-medium">{{ t("loading-more-swipe-bets") }}</span>
					</div>
				</div>
			</div>
		</div>
		<div
			class="select-none bg-cover absolute m-auto left-0 top-[34px] right-0 h-[330px] md:h-[359px] w-[288px] bg-light-50 dark:bg-dark-700 shadow-xl dark:shadow-lg dark:shadow-[#00A82645] rounded-2xl z-10"
			:style="{
				'background-image': `url('${config.public.kenticoDomain}/medialibraries/content.gmgamingsystems.com/Synapse/Misc/swipe-layer.png')`,
			}"
		></div>

		<div
			class="select-none bg-cover absolute m-auto left-0 right-0 top-[43px] h-[330px] md:h-[359px] w-[277px] bg-light-50 dark:bg-dark-700 shadow-xl dark:shadow-lg dark:shadow-[#00A82645] rounded-2xl z-0 mb-10"
			:style="{
				'background-image': `url('${config.public.kenticoDomain}/medialibraries/content.gmgamingsystems.com/Synapse/Misc/swipe-layer.png')`,
			}"
		></div>
	</div>
</template>
